import { tableStore } from '@/store/table';
import { useEffect } from 'react';

export const useDebounce = (keyword: string) => {
  const [searchTerm, setSearchTerm] = tableStore((state) => [
    state.searchTerm,
    state.setSearchTerm,
  ]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearchTerm(keyword);
    }, 200);

    return () => clearTimeout(timeout);
  }, [keyword, setSearchTerm]);

  return { searchTerm };
};
